import { metaDashBoard, Aditional, addLayoutToRoute } from './base_route'
const routes = [
    {
        path: '/dashboard_seller',
        name: 'Menu Vendedores',
        meta: {
            ...metaDashBoard,
            layout: 'system',
            typeRoute: 'seller'
        },
        component: () => import('@/views/Dashboard_seller.vue'),
        props: true,
      },
];

const router_seller =  routes.map((route) => addLayoutToRoute(route))  
export { router_seller }; 